import Vue from 'vue'
import App from './App.vue'
import { createStore } from './store'
import createRouter from './router/index'
import { sync } from 'vuex-router-sync'
import titleMixin from './utils/title'
import * as filters from './utils/filters'
import ElementUI from 'element-ui'
import 'babel-polyfill'
import api from './api/api.js'
import func from './assets/js/common.js'
import xss from './assets/js/htmlEscape'
import InfiniteLoading from 'vue-infinite-loading'
import VueLazyLoad from 'vue-lazyload'
import 'swiper/dist/css/swiper.css'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/template.css'

// mixin for handling title
Vue.mixin(titleMixin)

if (process.browser) {
    const VueAwesomeSwiper = require('vue-awesome-swiper')
    Vue.use(VueAwesomeSwiper)

    window.router = createRouter()

    const vm = new Vue()
    window.vm = vm
}

var seo = require('./assets/js/seo.json')
Vue.prototype.$seo = seo
Vue.prototype.$api = api
Vue.prototype.$func = func
Vue.prototype.$xss = xss
Vue.prototype.$api_host = process.env.API_ROOT
var global = require('./assets/js/global.json')
Vue.prototype.$global = global

Vue.use(VueLazyLoad, {
    error: '',
    loading: require('./assets/img/public/loading-01.svg'),
    attemp: 3
})

Vue.use(InfiniteLoading, { /* 配置 */ })

Vue.config.productionTip = false

Vue.use(ElementUI)

// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

// Expose a factory function that creates a fresh set of store, router,
// app instances on each call (which is called for each SSR request)
function createApp () {
    // create store and router instances
    const store = createStore()
    const router = createRouter()

    // sync the router with the vuex store.
    // this registers `store.state.route`
    sync(store, router)

    // create the app instance.
    // here we inject the router, store oand ssr context to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.
    const app = new Vue({
        router,
        store,
        render: h => h(App)
    })

    // expose the app, the router and the store.
    // note we are not mounting the app here, since bootstrapping will be
    // different depending on whether we are in a browser or on the server.
    return { app, router, store }
}
const { app, router, store } = createApp()

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__)
}

router.onReady(() => {
    app.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/main.js